import { del } from '@truefit/http-utils';

import useCognito from '@/features/authentication/hooks/useCognito';
import { markAccountAsNotRemembered } from '@/features/authentication/storage/knownAccountsRegistry';
import { Tracking } from '@/shared/services/tracking';

const useSignOut = () => {
  const cognito = useCognito();

  return async () => {
    // Capture email before sign-out clears the cognito context
    const currentEmail = cognito.userAttributes?.email;

    try {
      // Delete backend session FIRST (while token is still valid)
      await del('/v1.0/session');
    } catch (error) {
      console.error('Error deleting backend session:', error);
      // Continue with sign out even if backend call fails
    }

    cognito.signOut({
      onSuccess() {
        if (currentEmail) markAccountAsNotRemembered(currentEmail);
        Tracking.getInstance().signOut();
        window.location.href = '/sign-in';
      },

      onFailure() {
        if (currentEmail) markAccountAsNotRemembered(currentEmail);
        window.location.href = '/sign-in';
      },
    });
  };
};

export default useSignOut;
